import { useMemo } from 'react'
import {
  useIndexedDB,
  makeStorageHelpers,
  type CacheEnvelope,
  type IndexedDBOptions,
} from '../../Utils'

export const useCacheHelpers = (dbData: IndexedDBOptions = {}) => {
  const dbApi = useIndexedDB<CacheEnvelope<unknown>>({
    dbName: dbData.dbName ?? 'pll-db',
    storeName: dbData.storeName ?? 'cache',
    dbVersion: dbData.dbVersion ?? 1,
  })
  return useMemo(() => makeStorageHelpers(dbApi), [dbApi])
}
